export * from "./CreateHospital";
export * from "./HospitalsData";
